define('views/user/forgotpassword/resetpassword/resethome',["backbone",
        "text!views/root/root.html",
        "views/_base/baseview",
        "views/user/forgotpassword/resetpassword/resetpassword",        
        "models/shared/securityquestions/securityquestion",
        "views/user/forgotpassword/resetpassword/securityquestions",
        'views/shared/alerts/alert',
        'views/shared/modal/modal_modern'
], function (Backbone, Template,BaseView, ResetView,SecurityQuestion, SecurityView, AlertModalView, Modal) {
    "use strict";

    return BaseView.extend({
        id: "home",
        isRender: false,
        needsAuth: false,
        activityIndicator: false,
        initialize: function (options) {
            options = options || {};
            this.GUID = options.GUID;


            this.elementName = options.elementName;
            BaseView.prototype.initialize(this);
        },
        render: function () {
            var that = this;
            this.$el.html(Template);
            return this;
        },
        loadData:function(){

            var that = this;

            $.ajax({
                type: 'GET',
                async: false,
                url: pf.url + "/ResetPassword",
                contentType: "application/json",
                data: { GUID: that.GUID },
                success: function (model, resp) {
                    var UserGUID = model.UserGUID;
                    var sq = JSON.parse(model.SecurityQuestion);
                    that.securityQuestion = new SecurityQuestion(sq, { parse: true });
                    //if (that.securityQuestion.SecurityQuestionID > 0)// ****** DONOT REMOVE ******
                    //    that.securityQuestionView = new SecurityView({ UserGUID: UserGUID, model: that.securityQuestion, elementName: "#mainRegion" })
                    //else// ****** DONOT REMOVE ******
                        that.resetView = new ResetView({ GUID: that.GUID, elementName: "#mainRegion" });                    
                },
                error: function (resp) {
                    switch (resp.status) {
                        case 200:
                            var userGUID = model.UserGUID;
                            var sq = JSON.parse(model.SecurityQuestion);
                            that.securityQuestion = new SecurityQuestion(sq, { parse: true });
                            if (that.securityQuestion.SecurityQuestionID > 0)
                                that.securityQuestionView = new SecurityView({ model: that.securityQuestion, elementName: "#mainRegion" })
                            else
                                that.resetView = new ResetView({ GUID: that.GUID, elementName: "#mainRegion" });
                            break;
                        case 400:
                            that.showForgotPasswordAlert();
                            // pfdialog.error({ context: this, Body: "You have entered an invalid link. Please try again.", Title: "Invalid Link" });
                            // pf.navigate("/");
                            break;
                        case 401:
                            that.showForgotPasswordAlert();
                            // pfdialog.error({ context: this, Body: "You have entered an invalid link. Please try again.", Title: "Invalid Link" });
                            // pf.navigate("/");
                            break;
                    };
                }
            });
        },

        showForgotPasswordAlert: function(){

            this.reset_pw_alert_modal_view = new AlertModalView({
                // General
                calling_view       : this,
                alert_type         : 1,
                // Transactional
                is_transaction     : false,
                // Content
                alert_header       : 'This link is invalid',
                alert_message      : 'The reset link for your password has most likely expired. Try resetting it again.',
                // Default
                btn_label          : 'Retry',
                btn_color          : 'blue',
                btn_callback       : this.resetPasswordMODAL,
                btn_retry_callback : this.resetPasswordMODAL,
                // Confirm
                btn_confirm        : false,
                // Cancel
                btn_cancel         : true,
                btn_cancel_label   : 'Cancel',
                btn_cancel_callback: this.cancelResetPasswordMODAL,
                // Success
                btn_success        : true,
                btn_success_delay  : 700,
                btn_success_label  : 'OK',
                btn_success_message: 'Successfully sent the reset password link.',
                btn_success_callback: this.resetPasswordSuccessMODAL,
                // Error
                btn_error          : true,
                btn_error_delay    : 700,
                btn_error_label    : 'Retry',
                btn_error_cancel_label: 'Cancel',
                btn_error_message  : 'Please try again.',
                btn_error_callback : this.canceledResetPasswordOnErrorMODAL
            });

            this.alert_modal = new Modal({
                show        : true,
                content     : this.reset_pw_alert_modal_view.$el.html(),
                calling_view: this.reset_pw_alert_modal_view
            });

        },

        resetPasswordMODAL: function(processComplete, that){
            var that = (that) ? that : this;
            that.cancelResetPasswordMODAL();
            pf.navigate('forgotpassword');
        },

        cancelResetPasswordMODAL: function(that){
            var that = (that) ? that : this;

            that.alert_modal.$el.fadeOut(function(){
                that.alert_modal.$el.remove();
            });

        },

        resetPasswordSuccessMODAL: function(){
            // console.log('resetPasswordSuccessMODAL');
        },

        canceledResetPasswordOnErrorMODAL: function(){
            // console.log('canceledResetPasswordOnErrorMODAL');
        },

        close: function () {
            if(this.securityQuestionView)
                this.cleanup(this.securityQuestionView);
            if (this.resetView)
                this.cleanup(this.resetView);
        }
    });
});
